var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66666C10.84 2.66666 6.66663 6.84 6.66663 12C6.66663 14.32 7.33329 16.4933 8.54663 18.4533C9.81329 20.5067 11.48 22.2667 12.76 24.32C13.3866 25.32 13.84 26.2533 14.32 27.3333C14.6666 28.0667 14.9466 29.3333 16 29.3333C17.0533 29.3333 17.3333 28.0667 17.6666 27.3333C18.16 26.2533 18.6 25.32 19.2266 24.32C20.5066 22.28 22.1733 20.52 23.44 18.4533C24.6666 16.4933 25.3333 14.32 25.3333 12C25.3333 6.84 21.16 2.66666 16 2.66666ZM16 15.6667C14.16 15.6667 12.6666 14.1733 12.6666 12.3333C12.6666 10.4933 14.16 9 16 9C17.84 9 19.3333 10.4933 19.3333 12.3333C19.3333 14.1733 17.84 15.6667 16 15.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.c27e20da0a4889fbfb32c6faf6ead302.svg";
export { ForwardRef as ReactComponent };